import { render, staticRenderFns } from "./FileDiff.vue?vue&type=template&id=1bd7cf58&scoped=true&"
import script from "./FileDiff.vue?vue&type=script&lang=js&"
export * from "./FileDiff.vue?vue&type=script&lang=js&"
import style0 from "./FileDiff.vue?vue&type=style&index=0&id=1bd7cf58&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd7cf58",
  null
  
)

export default component.exports